import axios from "axios";
import loader from "../components/Loader";

export default {
  name: "user",
  data: () => ({
    user: {},
    loading: true
  }),
  components: {
    loader
  },
  created() {
    axios
      .get(`${process.env.API_URL}/user/mentor/${this.$route.params.id}`)
      .then(response => {
        this.loading = false;
        this.user = response.data;
      })
      .catch(err => alert(err.response.data.error));
  }
};
